import { Input } from "@chakra-ui/input";
import { Select } from "@chakra-ui/react";
import { useTranslations } from "next-intl";

import FormInputWraper from "../../Components/FormInputWrapper";
import type { FormInputProps } from "../../interfaces";
import { INPUT_SIZE, INPUT_VARIANT } from "../../RegisterPage";
import { COUNTRIES } from "lib/utils/constants";

export const FiscalNumberIdInput = ({ FormController, disabled, color }: FormInputProps) => {
  const t = useTranslations("pages.register");
  return (
    <FormInputWraper
      isRequired
      field_name="fiscal_id_number"
      key="fiscal_id_number_input"
      color={color}
      label={t("fiscalNumber")}
      FormController={FormController}
    >
      <Input
        id="fiscal_id_number"
        key="fiscal_id_number"
        variant={INPUT_VARIANT}
        size={INPUT_SIZE}
        {...FormController.register("fiscal_id_number", {
          required: t("fiscalNumberReqMessage"),
        })}
        isDisabled={disabled}
      />
    </FormInputWraper>
  );
};

export const AddressStreetInput = ({ FormController, disabled, color }: FormInputProps) => {
  const t = useTranslations("pages.register");
  return (
    <FormInputWraper
      label={t("addressStreet")}
      field_name="address_street"
      color={color}
      FormController={FormController}
      isRequired
    >
      <Input
        key="address_street"
        variant={INPUT_VARIANT}
        size={INPUT_SIZE}
        autoComplete="address"
        {...FormController.register("address_street", {
          required: t("addressStreetReqMessage"),
        })}
        isDisabled={disabled}
      />
    </FormInputWraper>
  );
};

export const AddressPostalCodeInput = ({ FormController, disabled, color }: FormInputProps) => {
  const t = useTranslations("pages.register");
  return (
    <FormInputWraper
      field_name="address_postal_code"
      color={color}
      isRequired
      label={t("addressPostalCode")}
      FormController={FormController}
    >
      <Input
        key="address_postal_code_input"
        variant={INPUT_VARIANT}
        size={INPUT_SIZE}
        autoComplete="zipCode"
        {...FormController.register("address_postal_code", {
          required: t("addressPostalCodeReqMessage"),
        })}
        isDisabled={disabled}
      />
    </FormInputWraper >
  );
};

export const AddressCityInput = ({ FormController, disabled, color }: FormInputProps) => {
  const t = useTranslations("pages.register");
  return (
    <FormInputWraper
      field_name="address_city"
      color={color}
      label={t("addressCity")}
      FormController={FormController}
      isRequired
    >
      <Input
        variant={INPUT_VARIANT}
        size={INPUT_SIZE}
        key="address_city_input"
        {...FormController.register("address_city", {
          required: t("addressCityReqMessage"),
        })}
        isDisabled={disabled}
      />
    </FormInputWraper >
  );
};

export const AddressCountryInput = ({ FormController, disabled, color }: FormInputProps) => {
  const t = useTranslations("pages.register");
  return (
    <FormInputWraper
      isRequired
      field_name="address_country"
      color={color}
      label={t("addressCountry")}
      FormController={FormController}
    >
      <Select
        key="address_country_input"
        isDisabled={disabled}
        {...FormController.register("address_country", {
          required: t("addressCountryReqMessage"),
        })}
      >
        {[{ code: "", name: t("selectCountry") }, ...COUNTRIES].map(country => {
          return (
            <option value={country.code} key={country.code}>
              {country.name}
            </option>
          );
        })}
      </Select>
    </FormInputWraper >
  );
};
